
import api from './src/config/api'
import routes from './src/config/routes'



export default {
    api:api,
    routes:routes
}